import { useEffect, useState, useContext } from "react";
import './skills.scss';
import Skill from "./Skill";
import LanguageContext from "../../Contexts/Language";
type skillProps = {
    scrollTop: number
    height: number,
}
const Skills = (props:skillProps) =>{
    const {language} = useContext(LanguageContext);
    const [isVisible, setIsVisible] = useState(false);
    const [random] = useState(Math.floor(Math.random() * language.skills.skills.length) - 1);

    useEffect(() =>{
        setIsVisible((props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) > 1300 / 6092)
    },[props.scrollTop])


    return(
        <div className="skills-container" style={{height: `${props.height}px`}}>
            <div className="skills-wrapper">
                {
                    language.skills.skills.map((skill,key) =>(  
                        <Skill skill={skill} id={key} key={key} show={isVisible} random={random} tooltip={language.skills.tooltip}/>
                    ))
                }
                <div className={`skills-text skills-text-${isVisible}`}>
                    <div className="skill-text-header">{language.skills.title}</div>
                    <p style={{animationDelay: "0.2s"}}>{language.skills.categories[0]}</p>
                    <p style={{animationDelay: "0.5s"}}>{language.skills.categories[1]}</p>
                    <p style={{animationDelay: "0.7s"}}>{language.skills.categories[2]}</p>
                </div>
            </div>
        </div>
    )
}
export default Skills